const LockFreezePage = () => {
  return (
    <div className="page">
      <div className="card">
        <h2 className="title">
          Introduction of Voluntary Lock-in / Debit freeze facility to Mutual
          Fund Folios for units held in non-demat mode:
        </h2>

        <p>
          Investors are hereby informed that pursuant to SEBI circular
          HO/24/12/12(5)2026-IMD-SEC-1/I/6373/2026 dated March 06, 2026, read
          with AMFI Best Practices Guidelines Circular No.124/ 2026-27 dated
          April 10, 2026, it has been decided to add following provisions of the
          captioned faility in the SAI of the Mutual Fund w.e.f.{" "}
          <b>April 30, 2026:</b>
        </p>

        <h4 className="section-title">Features :</h4>

        <table className="table">
          <tbody>
            <tr>
              <th>Applicability</th>
              <td>
                Available for all Resident and Non-Resident Individual
                investors.
              </td>
            </tr>

            <tr>
              <th>Who can Execute</th>
              <td>
                <ul style={{ listStyleType: "disc" }}>
                  The facility to lock / unlock will be available only to:
                  <li>
                    • First / sole holder in the folio, held in single and
                    anyone or survivor basis. held in single and Anyone or
                    Survivor basis.
                  </li>
                  <li>
                    • Guardian of the minor till the minor attains majority and
                    after obtaining maturity lock / unlock will be exercised by
                    the unit holder only
                  </li>
                </ul>
              </td>
            </tr>

            <tr>
              <th>Requirements</th>
              <td>
                <ul>
                  <li>• KYC in the folios should be Registered / Validated.</li>
                  <li>
                    • Folios should have valid Email ID and Mobile Number
                    registered in India.
                  </li>
                </ul>
              </td>
            </tr>

            <tr>
              <th>Options of locking / freezing</th>
              <td>
                <ul>
                  <li>• Lock only Debit transactions (investor initiated) </li>
                  <li>
                    • Lock debit transactions + non-financial transactions
                    (investor initiated)
                  </li>
                </ul>
              </td>
            </tr>

            <tr>
              <th>Period for locking</th>
              <td>
                There is no specific period. The lock will remain{" "}
                <b>“until revoked”</b> by the Investor.
              </td>
            </tr>
          </tbody>
        </table>

        <h4 className="section-title">
          1. Process for locking/freezing the folio/s for units held in
          non-demat mode:
        </h4>

        <ol type="a">
          <li>
            <b>a)</b> Investor(s) will log-in to MF Central portal after
            completing all applicable log-in validation process which includes
            providing PAN + email ID / mobile number, OTP based authentication
            to the email ID/ mobile number.
          </li>
          <li>
            <b>b)</b> On successful validation, investor will be provided with
            details of all his holdings viz., fund name, scheme, outstanding
            units and value of units (basis last available NAV) held in SOA
            form.
          </li>
          <li>
            <b>c)</b> Investors will select the option to lock the transactions.
          </li>
          <li>
            <b>d)</b> Investor will select the Fund Name and folios that he/ she
            chooses to lock.
          </li>
          <li>
            <b>e)</b> Once selected, OTP would be sent to the registered mobile
            number / email ID and upon successful validation of OTP, MF Central
            will send the requests to the respective RTA who would lock the
            folio and send confirmation to investor.
          </li>
          <li>
            <b>f)</b> Lock would be marked in the select folio(s) in RTA
            database instantly for holdings held in SoA form.
          </li>
        </ol>

        <h4 className="section-title">
          1.1 Transactions that will be allowed during the lock in period:
        </h4>

        <ul>
          <li>• IDCW payout or reinvestment</li>
          <li>• Updation of address as per KRA feed</li>
          <li>
            • Any request/ orders received by the RTA from Law Enforcement
            Authorities or Regulators iirespective of locking of units
          </li>
        </ul>

        <h4 className="section-title">
          1.2. Below transactions will be allowed only after unlocking the
          folio:
        </h4>

        <table className="table">
          <thead>
            <tr>
              <th>Financial Transactions</th>
              <th>Non Financial Transactions</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Redemptions</td>
              <td>Change/Addition of Bank Mandate</td>
            </tr>
            <tr>
              <td>Registration of STP</td>
              <td>Change of Broker Code</td>
            </tr>
            <tr>
              <td>Registration of SWP</td>
              <td>Change of Email id and/or Mobile Number</td>
            </tr>
            <tr>
              <td>Switches</td>
              <td>Nominee Registration/Cancellation</td>
            </tr>
            <tr>
              <td></td>
              <td>Change in IDCW option</td>
            </tr>
            <tr>
              <td></td>
              <td>Lien Marking</td>
            </tr>
            <tr>
              <td></td>
              <td>Change in Signature</td>
            </tr>
            <tr>
              <td></td>
              <td>Consolidation of Folios</td>
            </tr>
            <tr>
              <td></td>
              <td>Transfer of units</td>
            </tr>
            <tr>
              <td></td>
              <td>Change of Tax Status</td>
            </tr>
          </tbody>
        </table>
        <span>*The AMC currently does not offer DTP facility</span>

        <h4 className="section-title">
          1.3. Process for Unlocking the Folio/s.
        </h4>

        <ol type="a">
          <li>
            <b>a)</b> Investor(s) will log-in to MF Central portal after
            completing all applicable log-in validation process which includes
            providing PAN + email ID/ mobile number, OTP based authentication to
            the email ID/ mobile number.
          </li>
          <li>
            <b>b)</b> On successful validation, investor will be provided with
            details of all his holdings viz., fund name, scheme, outstanding
            units and value of units (basis last available NAV) held in SOA
            form.
          </li>
          <li>
            <b>c)</b> Investors will select the option to unlock the
            transactions.
          </li>
          <li>
            <b>d)</b> Investor will select the Fund Name and folios that he/ she
            chooses to unlock.
          </li>
          <li>
            <b>e)</b> Two levels of authorization would be mandated
            <br />• by sending different OTPs to the registered mobile number
            and email ID and both should get validated or
          </li>
          <li>
            <b>f)</b> After successful validation, MF Central will send the
            request to the respective RTA who would unlock the folio(s) and send
            confirmation to investor.
          </li>
        </ol>

        <h4 className="section-title">
          2. Process for locking the folio/s held in demat mode:
        </h4>

        <p>
          In case of demat mode, MF Central will provide an option for the
          investor to lock holdings held in demat account by redirecting
          investors to online services offered by respective depositories.
        </p>

        <p className="footer-text">
          For further details and processes, please visit our website{" "}
          <a href="www.jmfinancialmf.com">www.jmfinancialmf.com</a>
        </p>
      </div>

      <style>{`
        .page {
  background: #f4f4f4;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 40px 20px;
}

.card {
  background: #fff;
  width: 100%;
  max-width: 850px;
  padding: 35px;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.6;
}

/* ✅ FIX 1: PERFECT CENTER TITLE */
.title {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 15px;   /* slightly reduced */
  font-weight: 700;
  text-decoration: underline;
  margin-bottom: 20px;
}

/* ✅ FIX 2: CONTROL SECTION SIZE */
.section-title {
  margin-top: 18px;
  margin-bottom: 8px;
  font-size: 15px;   /* same as content (not big) */
  font-weight: 700;
}

/* ✅ FIX 3: STRONG TABLE BORDER */
.table {
  width: 100%;
  border-collapse: collapse;
  border: 2px solid #000;   /* OUTER BORDER FIX */
  margin-top: 10px;
  font-size: 14px;
}

/* inner borders */
.table th,
.table td {
  border: 1.5px solid #000;
  padding: 10px;
  vertical-align: top;
}

/* header row */
.table th {
  background: #f2f2f2;
  text-align: left;
  font-weight: 700;
}

/* ✅ IMPORTANT: TOP BORDER FIX */
.table thead tr th {
  border-top: 2px solid #000 !important;
}

.footer-text {
  margin-top: 20px;
  font-weight: 500;
}
        @media (max-width: 768px) {
          .card {
            padding: 20px;
          }

          .title {
            font-size: 14px;
          }

          .table {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default LockFreezePage;
